import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Module to route mapping
const moduleRoutes: { module: string; path: string }[] = [
  { module: 'dashboard', path: '/dashboard/overview' },
  { module: 'products', path: '/dashboard/products' },
  { module: 'customers', path: '/dashboard/customers' },
  { module: 'pos', path: '/dashboard/pos' },
  { module: 'sales', path: '/dashboard/sales' },
  { module: 'suppliers', path: '/dashboard/suppliers' },
  { module: 'purchase_orders', path: '/dashboard/purchase-orders' },
  { module: 'reports', path: '/dashboard/reports' },
  { module: 'tickets', path: '/dashboard/my-tickets' },
  { module: 'shop_config', path: '/dashboard/configuration' },
  { module: 'settings', path: '/dashboard/settings' },
];

/**
 * SmartRedirect component that redirects users to their first accessible module.
 * For shop owners, it defaults to dashboard.
 * For staff members, it redirects to the first module they have permission to view.
 */
const SmartRedirect: React.FC = () => {
  const { user, hasModuleAccess } = useAuth();

  // Shop owners have full access, redirect to dashboard overview
  if (user?.role === 'shop_owner') {
    return <Navigate to="/dashboard/overview" replace />;
  }

  // For staff members, find the first accessible module
  if (user?.role === 'shop_staff') {
    for (const route of moduleRoutes) {
      if (hasModuleAccess(route.module, 'view')) {
        console.log(`🔀 SmartRedirect: Redirecting staff to ${route.path} (first accessible module: ${route.module})`);
        return <Navigate to={route.path} replace />;
      }
    }
    
    // If no modules are accessible, show an error or redirect to a default page
    console.warn('🔀 SmartRedirect: Staff has no accessible modules');
    // Fallback to products page as it's commonly accessible
    return <Navigate to="/dashboard/products" replace />;
  }

  // Default fallback - for shop owners or other roles
  return <Navigate to="/dashboard/overview" replace />;
};

export default SmartRedirect;
